import _ from 'lodash';
export default [
  '/',
  '/inner/academics',
  '/track/ranking',
  '/academic/instructors',
  '/inner/grades',
  '/inner/advanced',
  '/inner/haa',
  '/inner/explore',
  '/academic/IMPACT',
  '/activities/house',
  '/activities/events',
  '/inner/communityS',
  '/inner/hxweek',
  '/instructions/eligibility',
  '/instructions/dates',
  '/instructions/process',
  '/instructions/tuition',
  '/about-us',
  '/about-us/partners',
  // '/join-us/si',
  '/join-us/volunteer',
  '/join-us/ffp',
  '/faq',
  '/inner/graduation-research'
].map(item => {
  let ret = {};
  if (_.isString(item)) {
    ret.pathname = item;
  } else {
    ret = { ...item };
  }
  return ret;
});
export const MOBILE_PATHS = [
  '/',
  '/inner/academics',
  '/track/ranking',
  '/academic/instructors',
  '/inner/graduation-research',
  '/inner/grades',
  '/inner/advanced',
  '/inner/explore',
  '/academic/IMPACT',
  '/activities/events',
  '/activities/house',
  // '/join-us/si',
  '/inner/haa',
  '/inner/hxweek',
  '/instructions/eligibility',
  '/instructions/dates',
  '/instructions/process',
  '/instructions/tuition',
  '/about-us',
  '/about-us/partners',
  '/join-us/ffp',
  '/join-us/volunteer',
  '/faq'
].map(item => {
  let ret = {};
  if (_.isString(item)) {
    ret.pathname = item;
  } else {
    ret = { ...item };
  }
  return ret;
});
